// Post-login destination (2026-09-18): single source of truth shared by
// LoginPage and the "/" root auth gate, so an added-to-homescreen PWA that
// starts at "/" lands on the SAME role-aware home the login flow uses
// instead of a hardcoded route.
export function getPostLoginDestination(role?: string): string {
  if (role === 'super_admin') return '/super-admin';
  if (role === 'admin' || role === 'sub_admin') return '/admin';
  if (role === 'treasurer' || role === 'directive') return '/directive';
  if (role === 'security') return '/security-dashboard';
  return '/home/dashboard';
}

export function getPostLoginDestinationFromStorage(): string {
  try {
    const storedUser = localStorage.getItem('user');
    return getPostLoginDestination(storedUser ? JSON.parse(storedUser)?.role : undefined);
  } catch {
    return getPostLoginDestination();
  }
}
